<div class="modal fade modal-full-width modal-full-height" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content" *ngIf="isOpen">
            <div class="modal-header">
                <h4 class="modal-title">
                    Atualizar Análise de Mercado
                </h4>
            </div>
            <div class="modal-body">
                <sgt-cliente-analise-mercado-lancamento-form
                    #form
                    [canEdit]="canEdit">
                </sgt-cliente-analise-mercado-lancamento-form>
            </div>
            <div class="modal-footer">

                <ng-template [ngIf]="canEdit">
                    <button type="button" class="btn btn-light" (click)="cancel()">
                        <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
                    </button>      
                    <button type="button" class="btn btn-success mr-2" (click)="save()" #btnSave>
                        <i class="fas fa-check" aria-hidden="true"></i> Salvar
                    </button>
                </ng-template>

                <ng-template [ngIf]="!canEdit">
                    <button type="button" class="btn btn-light" (click)="close()">
                        <i class="fas fa-times"></i> Fechar
                    </button>
                </ng-template>                
            </div>
        </div>
    </div>
</div>
